<script lang="ts" setup>
defineProps<{
  name: string
}>()
</script>

<template>
  <a
    class="
      cursor-pointer rounded-2xl bg-white px-3
      py-2 text-sm tracking-[-0.01em] text-main-dark !no-underline transition-colors
      hover:bg-main-green hover:text-white
    "
    href="#"
  >
    {{ name }}
  </a>
</template>
